// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1006":"d57cc4b9","61094":"d57cc4b9"}[chunkId] + ".chunk.css");